// Models and interfaces
import { IPatron } from './../../models/service/patron-details.model';
import { INursingStation } from 'src/app/models/service/nursing-stations.model';
import { IUnitsFilters, IUnitsDetailsGrouped, IUnitsFiltersItem } from '../../models/units/units-utilities.model';
import { ServiceTicketI } from '../../models/service/serviceTicket.model';
import { IPatronTrayDetails } from '../../models/service/patron-tray-details.model';

export class AAddNursingStations {
    static readonly type = '[Units] AddNursingStationA]';
    constructor(public readonly payload?: INursingStation[]) {}
}

export class AAddUnitDetails {
    static readonly type = '[Units] AAddUnitDetails]';
    constructor(public readonly payload?: IUnitsDetailsGrouped[]) {}
}

export class AAddTicketService {
    static readonly type = '[Units] AAddTicketService]';
    constructor(public readonly payload?: ServiceTicketI[]) {}
}


export class UpdateRoomFilter {
    static readonly type = '[Units] UpdateRoomFilter]';
    constructor(public readonly payload?: IUnitsFilters) {}
}

export class AAddPatronDetails {
    static readonly type = '[Units] AAddPatronDetails]';
    constructor(public readonly payload?: IPatron) {}
}

export class AAddPatronTrayDetails {
    static readonly type = '[Units] AAddPatronTrayDetails]';
    constructor(public readonly payload?: IPatronTrayDetails) {}
}

export class UpdateMealFilter {
    static readonly type = '[Units] UpdateMealFilter]';
    constructor(public readonly payload?: IUnitsFiltersItem[]) {}
}
